<template>
  <div class="container">
    <search-box
      frompage="正文内容"
      @changeMainBody="changeMainBody"
    />

    <!-- <searchBox @changeMainBody="changeMainBody"></searchBox> -->
    <div class="que-box">
      <div class="que-gray-box">
        <span
          v-if="detailData.categoryResponse"
          class="curPoint"
          @click="goAsideList(detailData.categoryID)"
        >{{ detailData.categoryResponse.categoryNameWithCulture }}</span>
        <span v-if="detailData.subCategoryResponse">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
        <span
          v-if="detailData.subCategoryResponse"
          class="curPoint"
          @click="goAsideList(detailData.subCategoryID)"
        >{{ detailData.subCategoryResponse.categoryNameWithCulture }}</span>
      </div>
      <div class="detail-title">
        <div>{{ detailData.titleNameWithCulture }}</div>
      </div>
      <div class="detail-container">
        <div
          @click="addComment($event)"
          v-html="htmlData"
        />
        <!-- 相关文章 -->
        <div class="about-articl">
          <div class="labelsbox">
            <span
              v-for="(item, index) in labels"
              :key="index"
              class="labelbox"
              @click="toSearchResult(item)"
            >
              {{ item }}
            </span>
          </div>
          <template v-if="abouteData && abouteData.length > 0">
            <div class="about-title">
              相關文章
            </div>
            <div
              v-for="(item, index) in abouteData"
              :key="index"
              class="about-item"
            >
              <div
                class="item-text"
                @click="toMainBody(item.id, item.titleNameWithCulture, 'relatedArticle')"
              >
                <span style="color: #e70e1a; font-weight: 700">></span>{{ item.titleNameWithCulture }}
              </div>
            </div>
          </template>
        </div>
        <!-- 最近查看文章 -->
        <div
          v-if="recentData && recentData.length > 0"
          class="about-articl"
          style="border-top: none; margin-top: 0"
        >
          <div class="about-title">
            最近查看的文章
          </div>
          <div
            v-for="(item, index) in recentData"
            :key="index"
            class="about-item"
          >
            <div
              class="item-text"
              @click="toMainBody(item.id)"
            >
              <span style="color: #e70e1a; font-weight: 700">></span>{{ item.titleNameWithCulture }}
            </div>
          </div>
        </div>
        <el-image-viewer
          v-if="showViewer"
          :on-close="closeViewer"
          :url-list="srcList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from './searchBox.vue';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
    components: {
        SearchBox,
        ElImageViewer
    },
    data() {
        return {
            detailData: {},
            labels: [],
            htmlData: '',
            abouteData: [],
            showViewer: false,
            srcList: [],
            recentData: []
        };
    },
    watch: {
        $route(to, from) {
            if (to.query.questionId != from.query.questionId) {
                this.getquestion(to.query.questionId);
                this.GetRecommendById(to.query.questionId);
                let arr = [];
                if (JSON.parse(localStorage.getItem('questionId'))) {
                    arr = JSON.parse(localStorage.getItem('questionId'));
                    this.getrecentquestion(arr);
                }
            }
        }
    },
    created() {
        this.getquestion(this.$route.query.questionId);
        this.GetRecommendById(this.$route.query.questionId);
        let arr = [];
        if (JSON.parse(localStorage.getItem('questionId'))) {
            arr = JSON.parse(localStorage.getItem('questionId'));
            this.getrecentquestion(arr);
        }
    },
    methods: {
        toSearchResult(item) {
            this.$store.commit('changesearchBox', item);
            //* 可退回瀏覽歷史
            // this.$router.push({ name: this.pub.routeNameLists.HelpSearchResult, query: { selcon: this.$store.state.searchBox}});

            // this.$router.push({ name: this.pub.routeNameLists.HelpSearchResult });
        },
        changeMainBody(id) {
            this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: id } });
        },
        toMainBody(id, titleNameWithCulture, type) {
            this.$store.commit('changefrompage', '幫助中心文章詳情頁');
            if (type == 'relatedArticle') {
                gio('track', 'element_click', {
                    channel: '幫助中心',
                    location: `幫助中心文章詳情_${titleNameWithCulture}`,
                    element_content: titleNameWithCulture,
                    element_link: `/helpcenter/mainbody?questionId=${id}`,
                    element_name: titleNameWithCulture,
                    page: '幫助中心文章詳情頁',
                    platform: 'web'
                });
                gio('evar.set', {
                    evar_ad_position: `幫助中心文章詳情頁_${titleNameWithCulture}`,
                    evar_page: '幫助中心文章詳情頁'
                });
            }
            this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: id } });
            this.$nextTick(function () {
                let main = document.querySelector('.el-main');
                main.scroll({
                  top:0,
                  left: 0,
                  behavior: 'smooth'
                });
            });
            let arr = [];
            if (JSON.parse(localStorage.getItem('questionId'))) {
                arr = JSON.parse(localStorage.getItem('questionId'));
            } else {
                arr = [];
            }
            arr = [...new Set(arr)];
            arr.unshift(id);
            if (arr.length > 5) {
                arr.pop();
            }
            localStorage.setItem('questionId', JSON.stringify(arr));
        },
        closeViewer() {
            this.showViewer = false;
        },
        addComment(event) {
            this.srcList = [];
            if (event.target.nodeName === 'IMG') {
                this.srcList.push(event.target.src);
                this.showViewer = true;
            }
        },
        goAsideList(categoryID) {
            this.$router.push({ path: '/helpcenter/asidelist', query: { categoryID: categoryID } });
        },
        getrecentquestion(val) {
            try {
                this.axios.post(this.pub.getApi().GetQuestionByIds, val).then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.recentData = res.data.result;
                    }
                });
            } catch (error) {}
        },
        GetRecommendById(val) {
            try {
                this.axios
                    .get(this.pub.getApi().GetRecommendById, {
                        params: {
                            id: val
                        }
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            this.abouteData = res.data.result;
                        }
                    });
            } catch (error) {}
        },

        getquestion(val) {
            this.axios.get(this.pub.getApi().GetQuestionById, { params: { id: val } }).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.detailData = res.data.result;
                    this.labels = res.data.result.labels;
                    let reg = new RegExp('<table', 'g');
                    let reg1 = new RegExp('</table>', 'g');
                    let htmlData1 = res.data.result.contentWithCulture.replace(reg, '<div class="test-div"><table');
                    this.htmlData = htmlData1.replace(reg1, '</table></div>');
                    gio('track', 'enter_in', {
                        channel: '幫助中心',
                        page: '幫助中心文章詳情頁',
                        platform: 'web',
                        from: this.$store.state.fromPage
                    });
                    // if (res.data.result.videoPath.indexOf('www.youtube.com') > -1) {
                    //     var matchReg = /\<video.*?video\>/gi;
                    //     let tmpurl = res.data.result.videoPath.replace('https:', '');
                    //     tmpurl = tmpurl.replace('watch?v=', 'embed/') + '?wmode=transparent';
                    //     this.htmlData = htmlData1.replace(res.data.result.contentWithCulture.match(matchReg), `<iframe id="ifrId" src="${tmpurl}" frameborder="0" width="100%" height="90%" ></iframe>`);
                    // }
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.container {
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f3f3f5;
    text-align: left;
    .que-box {
        border-radius: 15px;
        background-color: #fff;
        margin-top: 30px;
        padding: 30px;
        .que-gray-box {
            font-size: 16px;
            color: #999999;
            .curPoint {
                cursor: pointer;
            }
        }
    }
    .detail-title {
        padding-top: 20px;
        height: 46px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 30px;
        color: #333333;
        letter-spacing: 0;
        line-height: 46px;
        div {
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 20px;
        }
    }
    .top-divider {
        width: 100%;
        height: 7px;
        opacity: 0.26;
        background: #f5f6f7;
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.09);
    }
    .detail-container {
        margin-top: 50px;
        padding-bottom: 45px;
        /deep/ img {
            max-width: 100%;
        }
        /deep/ video {
            width: 100%;
        }
        .about-articl {
            // border-top: 1px solid #eeeeee;
            // margin-top: 12px;
            padding-top: 24px;
            .labelsbox {
                margin-bottom: 25px;
                .labelbox {
                    color: #0062ff;
                    font-size: 18px;
                    cursor: pointer;
                    margin-right: 45px;
                    margin-bottom: 25px;
                }
            }
            .about-title {
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                font-size: 16px;
                color: #333333;
                letter-spacing: 0;
                margin-bottom: 16px;
            }
            .about-item {
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                .more-icon {
                    width: 12px;
                    height: 12px;
                    margin-right: 6px;
                }
                .item-text {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                    letter-spacing: 0;
                    cursor: pointer;
                }
                .item-text:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    /deep/ ol {
        list-style: decimal;
        line-height: 24px;
        padding-left: 16px;
        li {
            color: #333333;
            font-size: 16px;
            margin-bottom: 10px;
        }
    }

    /deep/ ul {
        list-style: disc;
        line-height: 24px;
        padding-left: 16px;
        li {
            color: #333333;
            font-size: 16px;
            margin-bottom: 10px;
        }
    }
    /deep/ table {
        border-collapse: collapse;
    }
    /deep/ th {
        border: 1px solid #e8e8e8;
        line-height: 1.5;
        min-width: 50px;
        padding: 3px 5px;
        background-color: #fafafa;
        font-weight: 700;
        text-align: center;
    }
    /deep/ td {
        border: 1px solid #e8e8e8;
        line-height: 1.5;
        min-width: 50px;
        height: 20px;
        padding: 3px 5px;
        text-align: left;
    }
    /deep/ .test-div {
        width: 100%;
        overflow-y: auto;
        margin: 12px 0;
    }
    /deep/ p {
        line-height: 24px;
    }
    /deep/ a {
        color: #41a1f4;
    }
    /deep/ a:hover {
        text-decoration: underline;
    }
}
</style>
